import { computed, ref } from "vue";
import { shortFormatDate } from "@/services/date/date-format";

export interface StagedLicense {
  organizationNm: string;
  expirationDate: string;
  token: string;
}

export type StagedLicenseEncoded = string;

export const useStagedLicense = (initialLicense: StagedLicenseEncoded) => {
  let stagedLicenseRaw;

  try {
    stagedLicenseRaw = initialLicense ? JSON.parse(atob(initialLicense)) : null;
  } catch {
    stagedLicenseRaw = null;
  }

  const isValid = ref(!!stagedLicenseRaw);
  const stagedLicense = ref<StagedLicense>(stagedLicenseRaw);
  const rawStagedLicense = ref(initialLicense);
  const isAvailable = ref<boolean>(!!initialLicense);
  const organizationName = ref<string | undefined>(
    stagedLicense.value?.organizationNm
  );
  const expirationDate = ref<Date | undefined>(
    stagedLicense.value?.expirationDate
      ? new Date(stagedLicense.value?.expirationDate)
      : undefined
  );
  const token = ref(stagedLicense.value?.token);
  const expirationDateFormatted = computed(() => {
    return shortFormatDate(expirationDate.value);
  });

  return {
    isValid,
    isAvailable,
    expirationDate,
    expirationDateFormatted,
    organizationName,
    token,
    rawStagedLicense,
  };
};
